import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { dateHelpers } from '../../helpers';
import EventsCard from "../dashboardNew/components/cards/EventsCard";

export default function EventsSlice(props) {
    const events = props.events;

    return (
        <div className="container events-list-wrapper">
            <div className="row">
                {
                    events && events.length > 0 && events.map((event, index) => (
                        <EventsCard
                            key={index}
                            eventsData={event}
                        />
                    ))
                }
            </div>
        </div>
    )
}

EventsSlice.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        index: PropTypes.number,
        image: PropTypes.string,
        url_eventbrite: PropTypes.string,
        date: PropTypes.string,
        country: PropTypes.string,
        city: PropTypes.string,
        description: PropTypes.string
    }))
}



// WEBPACK FOOTER //
// src/client/components/slices/EventsSlice.js